import React from 'react';
import './Services.css';

const services = [
  {
    icon: '📋',
    title: 'University Selection',
    desc: 'We match you with the best universities based on your grades, budget, and career goals across all partner countries.',
  },
  {
    icon: '📝',
    title: 'Application Assistance',
    desc: 'Our experts guide you through every step of the application — from SOPs to recommendation letters.',
  },
  {
    icon: '✈️',
    title: 'Visa Processing',
    desc: '98% visa success rate. We prepare a complete and compelling visa application on your behalf.',
  },
  {
    icon: '💰',
    title: 'Scholarship Guidance',
    desc: 'Discover scholarships and financial aid you qualify for. We\'ve helped students save thousands.',
  },
  {
    icon: '🏠',
    title: 'Accommodation Help',
    desc: 'From on-campus dorms to private rentals — we help you find safe, affordable housing.',
  },
  {
    icon: '📚',
    title: 'Pre-Departure Briefing',
    desc: 'Full orientation covering culture, banking, health insurance, and what to expect on arrival.',
  },
  {
    icon: '🎓',
    title: 'Course Counselling',
    desc: 'Expert academic advisors help you choose the right course and program for your future career.',
  },
  {
    icon: '🤝',
    title: 'Post-Arrival Support',
    desc: 'We don\'t disappear after departure. Our alumni network and student support is always available.',
  },
];

export default function Services() {
  return (
    <section className="services" id="services">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-tag">What We Offer</span>
          <h2 className="section-title">End-to-End <span className="gold-text">Student Support</span></h2>
          <p className="section-sub">One agency, complete support. From the first consultation to your first day of class — and beyond.</p>
        </div>

        <div className="services-grid">
          {services.map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
